<template>
  <div class="panel-components-hidden-elements" v-show="show">
    <div class="he-heading">
      <h5>{{ $t(`ct-panel-move-order`)}}</h5>
    </div>
    <div class="he-container">
      <panels-to-move ref="panelToMove" @functionChangeOrderPanel="changeOrderPanel"></panels-to-move>
    </div>
  </div>
</template>

<script>
import PanelsToMove from "../../apps/Panel/PanelsToMove";

export default {
  name: "PanelMoveOrder",
  components:{
    PanelsToMove
  },
  data() {
    return {
      elements: [],
      show: false
    }
  },

  methods: {
    showPanel() {
      this.show = !this.show;

      if(this.show) {
        this.$refs.panelToMove.makePanelsToOrder();
      }

      return this.show;
    },
    hidePanel() {
      this.show = false;
      this.$refs.panelToMove.cancelMove();
      return this.show;
    },

    changeOrderPanel(data) {
      this.$emit('functionChangeOrderPanel', data);
      this.hidePanel();
    }
  }
}
</script>

<style scoped>
  .he-container {
    overflow-y: auto;
    max-height: 500px;
    padding: 0 30px 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/base/sidebar/PanelMoveOrder.vue